// Backbone View for tooltips
var $ = jQuery;
var GroupTooltipDivider = Backbone.View.extend({
    initialize: function (options) {
        var layout = model.get('layout');
        // we set current block on call, so we need options array to bind data properly
        this.options = options;
        _.bindAll(this, 'bindings');
    },
    bindings: function () {
        var layout = model.get('layout');
        var result = {};
        var field = this.options.field_name;
        var field_model = 'styles.' + layout + '.' + field;
        result['[name="group_' + field + '_color"]'] = field_model + '_color'; // block top margin
        result['[name="group_' + field + '_width"]'] = field_model + '_width'; // divider width
        result['[name="group_' + field + '_top_margin"]'] = field_model + '_top_margin'; // block top margin


        return result;
    },
    render: function(){
        this.stickit();
        return this;
    },
    close: function(){
        this.unstickit();
        //delete this.$el;
        //delete this.el;
    }
});